exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.tab-array{width:100%;height:56px;display:-webkit-flex;display:flex;-webkit-flex-wrap:wrap;flex-wrap:nowrap;padding:0;margin-left:8px;margin-right:8px;background-color:#f7f7f7;border-bottom:2px solid #9b9b9b;box-sizing:border-box}.tab-array.border-top{border-top:1px solid #9b9b9b}.tab-array .link{text-decoration:none;color:inherit}.tab-array .tab{height:56px;width:auto;position:relative;box-sizing:border-box}.tab-array .tab .tab-item-decoration{font-family:Oswald,sans-serif;font-size:12px;width:29px;height:17px;position:absolute;font-weight:500;line-height:14px;top:2px;right:4px;background-color:#184e78;color:#fff;border-radius:4px;border:2px solid #fff;z-index:0;text-align:center}.tab-array .tab .tab-label{border-radius:4px;font-family:Oswald,sans-serif;font-size:24px;font-weight:300;font-style:normal;font-stretch:normal;top:6px;line-height:20px;letter-spacing:normal;color:#2c2c2c;margin:12px 16px;text-align:center;position:relative;cursor:pointer;z-index:1;background-color:#f7f7f7}.tab-array .tab .tab-label.selected{background-color:#fff}.tab-array .tab .tab-label.disabled{color:#9b9b9b;cursor:default}.tab-array .tab.disabled{cursor:default}.tab-array .tab.selected{cursor:default;background-color:#fff;border-bottom:none;border-left:2px solid #184e78;border-right:2px solid #184e78}.tab-array .tab.selected .tab-label{margin-top:12px;color:#184e78}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/TabbedPageControl/TabbedPageControl.scss
// module id = 1623
// module chunks = 0